<template>
  <div class="all">
    <Nav current="公司后台"></Nav>
    <div class="content">
      <div class="title">添加菜单</div>
      <div class="form">
        <div class="form_item">
          <div class="item_name">上级菜单</div>
          <div class="item-r">
            <span class="item_name" v-if="dataList.parentId == null "
              >无上级菜单<a href="#" @click="showDisappearParent">选择</a></span
            >
            <span class="item_name" v-else
              >{{ dataList.parentName
              }}<a href="#" @click="showDisappearParent">选择</a></span
            >
          </div>
        </div>

        <div class="form_item">
          <div class="item_name">菜单名称</div>
          <div class="item-r">
            <input type="text" v-model="dataList.name" />
          </div>
        </div>
        <div class="form_item">
          <div class="item_name">打开位置</div>
          <div class="item-r">
            <select v-model="dataList.target">
              <option value="_self">原窗口</option>
              <option value="_blank">新窗口</option>
            </select>
          </div>
        </div>
        <div class="form_item">
          <div class="item_name">是否限制范围</div>
          <div class="item-r">
            <input
              class="checkbox"
              type="checkbox"
              v-model="dataList.hasDataRange"
            />
          </div>
        </div>
        <div class="form_item">
          <div class="item_name">是否导航性菜单</div>
          <div class="item-r">
            <input class="checkbox" type="checkbox" v-model="dataList.isMenu" />
          </div>
        </div>
        <div class="form_item">
          <div class="item_name">生成访问项</div>
          <div class="item-r">
            <input
              class="checkbox"
              type="checkbox"
              v-model="dataList.extView"
            />
          </div>
        </div>
        <div class="form_item">
          <div class="item_name">是否启用子系统配置</div>
          <div class="item-r">
            <input
              class="checkbox"
              type="checkbox"
              v-model="dataList.isBusinessSystem"
            />
          </div>
        </div>
        <div class="form_item">
          <div class="item_name">引用编号</div>
          <div class="item-r">
            <input type="text" v-model="dataList.opCode" />
          </div>
        </div>
        <div class="form_item">
          <div class="item_name">tab编号</div>
          <div class="item-r">
            <input type="text" v-model="dataList.tabNum" />
          </div>
        </div>
        <div class="form_item">
          <div class="item_name">排序</div>
          <div class="item-r">
            <input type="text" v-model="dataList.sortNum" />
          </div>
        </div>
        <div class="form_item">
          <div class="item_name">链接地址</div>
          <div class="item-r">
            <input type="text" v-model="dataList.url" />
          </div>
        </div>
        <div class="form_item">
          <div class="item_name">vip 功能描述</div>
          <div class="item-r">
            <input type="text" v-model="dataList.vip" />
          </div>
        </div>
        <div class="form_item">
          <div class="item_name">功能描述</div>
          <div class="item-r">
            <el-input
              style="width: 216px"
              type="textarea"
              resize="vertical"
              v-model="dataList.description"
            >
            </el-input>
          </div>
        </div>
      </div>
    </div>

    <!-- 弹框  -->
    <div class="ec_tip none" ref="none">
      <div class="ec-title">
        请选择部门 <span id="close" @click="disappear">x</span>
      </div>
      <div class="ec-cont"></div>
      <div class="tree">
          <!-- :default-expanded-keys="[dataList.parentId]" -->
        <el-tree
          :data="menuList"
          show-checkbox
          :default-checked-keys="[dataList.parentId]"
          node-key="id"
          check-strictly
          :expand-on-click-node="false"
          ref="treeForm"
          :props="defaultProps"
          @check-change="handleNodeClick1"
        >
        </el-tree>
      </div>
      <div class="ec-but">
        <input type="button" value="确定" @click="disappear" />
      </div>
    </div>
    <div class="mask none" ref="none"></div>
    <el-row class="el-row">
      <el-button type="primary" class="el-button btnSty" @click="updateMrnu"
        >保存</el-button
      >
      <el-button class="el-button btnret" @click="retSupers">返回</el-button>
    </el-row>
  </div>
</template>
<script>
import Nav from "@/components/Nav.vue";
import apiData from "@/config/api";
import http from "@/config/httpConfig";
export default {
  components: {
    Nav,
  },
  data() {
    return {
      dataList: {
        parentName: "",
        parentId: "",
        name: "",
        target: "",
        hasDataRange:false,
        extView: false,
        isMenu: false,
        isBusinessSystem:false,
        sortNum: "",
        vip: "",
        parentId: "",
        opCode: "",
        tabNum: "",
        url: "",
        description: "",
        level: "",
        status: "",
        dynamic: "",
        dynamicSub: "",
        
        
      },
     
      disabledList: [],
      menuList: [],
      defaultProps: {
        children: "children",
        label: "name",
      },
      checkedId: "",
      checkedName: "",
    };
  },
  created() {
     this.getRow()
     console.log(this.dataList.parentId)
  },
  mounted() {
   
  },
  methods: {
    getRow(){
      this.dataList.parentName =this.$route.query.name
      this.dataList.parentId =this.$route.query.parentId
      // console.log(this.dataList.parentName)

      
    },
    updateMrnu() {
      let _this = this;
      let params = _this.dataList
      // console.log("参数", params);
      http.post(apiData.menuAdd, true, params, (res) => {
        if (res.data.code == 200) {
           this.$router.push('/company/adminMenu');
        } else {
          
        }
      });
    },
    retSupers(){
      this.$router.go(-1);
    },
    //选择上级菜单
    showDisappearParent() {
      let _this = this;
      _this.disabledList = document.getElementsByClassName("none");
      for (var i = 0; i < _this.disabledList.length; i++) {
        _this.disabledList[i].style.display = "block";
      }
      let params = {};
      http.get(apiData.menuList, true, params, function (res) {
        _this.menuList = res.data.data;
        console.log(res.data);
      });
    },
    disappear() {
      let _this = this;
      //蒙层消失
      for (var i = 0; i < _this.disabledList.length; i++) {
        _this.disabledList[i].style.display = "none";
      }
    },
    //@check-change实现单选
    handleNodeClick1(data, checked, node) {
      // console.log(1);
      let _this = this;
      if (checked === true) {
        this.checkedId = data.id;
        this.checkedName = data.name;
        _this.dataList.parentName = data.name;
        _this.dataList.parentId = data.id;
         this.$nextTick(() => {
          this.$refs.treeForm.setCheckedNodes([data]);
          // this.$refs.treeForm.setCheckedKeys([]);
        });
      } 
    },

    parentMenu() {
      let _this = this;
    },
    retSuper() {
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped lang="less">
.all {
  width: 100%;
  .el-row {
    width: 410px;
    margin: 50px auto;
  }
}
.content {
  text-align: left;
  width: 100%;
  margin-bottom: 20px;
  .title {
    width: 100%;
    height: 56px;
    line-height: 56px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #333333;
    text-indent: 10px;
    float: left;
  }

  .form {
    .form_item {
      display: flex;
      width: 100%;
      height: 40px;
      font-size: 14px;
      line-height: 40px;
      text-indent: 10px;

      input {
        width: 200px;
        height: 30px;
        margin-top: 5px;

        background: transparent;
        border: 1px solid rgb(204, 204, 204);
        text-indent: 10px;
      }
      .btn {
        width: 50px;
        color: #6cbef6;
      }
      .radio {
        line-height: 40px;
        .el-radio {
          margin: 0;
        }
      }
      .xing-huang {
        color: #ffba1a;
      }
      .xing-lv {
        color: #55c4b8;
      }
    }

    .item_name {
      width: 340px;
      display: block;
      color: #666;
      padding-left: 10px;
    }
    .item-r {
      width: 100%;
      select,
      input {
        width: 216px;
        height: 30px;
      }
      span a {
        margin-left: 5px;
        color: blue;
      }
      .checkbox {
        width: 13px;
        height: 13px;
        text-align: left;
      }
    }

    .form_item:nth-child(odd) {
      background: #f8f8f8;
    }
  }
}

.mask {
  width: 100%;
  height: 980px;
  position: absolute;
  top: 0;
  display: none;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;
}

/* 弹框 */
.ec_tip {
  width: 460px;
  height: 70%;
  display: none;
  position: absolute;
  left: 40%;
  top: 100px;
  background: #f8f8f8;
  color: #fff;
  z-index: 99999;
}

.ec-title {
  width: 100%;
  height: 40px;
  background-color: #75c0b6;
  text-align: center;
  line-height: 40px;
  position: relative;
}

.ec-title span {
  width: 20px;
  height: 20px;
  display: block;
  line-height: 16px;
  border: 1px solid #fff;
  border-radius: 50%;
  float: right;
  margin: 10px 10px 0 0;
}

.ec-but {
  position: absolute;
  bottom: 30px;
  margin: 0 auto;
}

.ec-but input {
  width: 200px;
  height: 40px;
  margin-left: 128px;
  float: left;
  border-radius: 5px;
  background-color: #fff;
}
.ec-cont {
  padding: 20px 0 0 20px;
  color: #000;
  display: flex;
  margin-left: 15px;
  input {
    width: 363px;
    height: 30px;
    padding: 4px 6px 4px 5px;
    border: 1px solid #ccc;
    text-align: center;
  }
  i {
    width: 30px;
    height: 30px;
    font-size: 25px;
    margin-top: 2px;
    display: block;
    margin-left: 5px;
    color: #ccc;
  }
}
.endTime_tr {
  float: left;
}
.tree {
  margin-top: 15px;
}
.el-tree {
  height: 370px;
  overflow-x: hidden;
}

.ec-but input:first-child {
  color: #fff;
  background-color: #75c0b6;
  border: 1px solid #75c0b6;
}

.active {
  background-color: #eee;
}

.btnret:hover {
  background: #55c4b8;
  color: #f8f8f8;
}
.el-button:hover {
  background: #55c4b8;
  border: 1px solid #55c4b8;
  color: #f8f8f8;
}
.el-button {
  width: 200px;
  height: 40px;
  border: 1px solid #55c4b8;
  color: #55c4b8;
}

.btnSty {
  background: #55c4b8;
  color: #fff;
}
.btnSty:hover {
  background: #55c4b8;
  color: #fff;
  border: 1px solid #55c4b8;
}
</style>
